import moment from 'moment'

export function formatMonth(str: string) {
  const [year, month] = str.split('-')
  return moment.monthsShort()[parseInt(month) - 1] + '-' + year
}
